/*
 * Date: 2025
 * Description: Dedicated modal for views like parts or users.
 * Author: Philippe Leroux @ Skitsc
 */

//Module
import { Modal , Box , Typography , IconButton, Paper } from "@mui/material"
import { i_view_modal_props } from "../../interfaces/utility.interface"
import { Fragment, ReactElement } from "react";

//Icons
import CloseIcon from '@mui/icons-material/Close';

//Utils && Constants
import { default_user } from "../../utils/constant";
import { formatTimestamp } from "../../utils/utility";

const ViewModal = ( props : i_view_modal_props ) => {
    const title = {
        fontSize : 20, fontWeight : 800 , marginRight : '12px'
    }
    const box = { display : 'flex' , width : '100%' , margin : 1}
    const item = { alignContent : 'center' , fontSize : 18}
    const RenderListCount = () : ReactElement=> {
        let total : number = 0;
        for(var i : number = 0; i < props.selected.list.length; i++) {
            if(props.selected.list[i].status !== 'initial' || props.selected.list[i].status === 'cancelled') {
                total++
            }
        }
        return (
            <Fragment>
                {total > 0 && 
                    <Box sx={box}>
                                <Typography sx={title}>Order passed : </Typography>
                                <Typography sx={item}>{total}</Typography>
                    </Box>
                }
            </Fragment>
        )
    }
    return (
    <Modal open={ props.type === 'part' ? props.selected !== '' : props.selected?._id !== ''} onClose={() => props.setSelected(props.type === 'part' ? '' : default_user)}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100vw', }} >
            <Box sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: 2, maxWidth: '90%', maxHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth : '400px' }} >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    {props.type === 'part' ? <Typography variant="h6">Part Details - {props.selected}.</Typography> 
                        :
                        <Typography variant="h6">User Details.</Typography>  
                    }
                    <IconButton onClick={() => props.setSelected(props.type === 'part' ? '' : default_user)}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                {props.type === 'part' &&
                    <Box component="img" src={props.path + props.selected} sx={{ maxWidth: '100%', maxHeight: '90vh', objectFit: 'contain', mt: 2 }} />
                }
                {props.type === 'user' &&
                    <Paper elevation={4} sx={{ padding :2 , width : '100%' , minWidth : '600px'}}>
                        <Box sx={box}>
                            <Typography sx={title}>User name : </Typography>
                            <Typography sx={item}>{props.selected.user.username}</Typography>
                        </Box>
                        <Box sx={box}>
                            <Typography sx={title}>Email : </Typography>
                            <Typography sx={item}>{props.selected.user.email}</Typography>
                        </Box>
                        <Box sx={box}>
                            <Typography sx={title}>Phone : </Typography>
                            <Typography sx={item}>{props.selected.user.phone}</Typography>
                        </Box>
                        {props.selected.address &&
                            <Box sx={box}>
                                <Typography sx={title}>Address : </Typography>
                                <Typography sx={item}>{props.selected.user.address.street}, {props.selected.user.address.city}, {props.selected.user.address.state}, {props.selected.user.address.zipcode}</Typography>
                            </Box>
                        }
                        <RenderListCount/>
                        { props.selected.user.creditLimit &&
                            <Box sx={box}>
                                <Typography sx={title}>Credit Limit : </Typography>
                                <Typography sx={item}>{props.selected.user.creditLimit} $</Typography>
                            </Box>
                        }
                        <Box sx={box}>
                            <Typography sx={title}>Last Payment : </Typography>
                            <Typography sx={item}>Needed !?</Typography>
                        </Box>
                        <Box sx={box}>
                            <Typography sx={title}>Last login : </Typography>
                            <Typography sx={item}>{formatTimestamp(props.selected.user.lastLogin)}</Typography>
                        </Box>
                        <Box sx={box}>
                            <Typography sx={title}>Validated phone : </Typography>
                            <Typography sx={item}>{props.selected.user.validated ? "Yes" : "No"}</Typography>
                        </Box>
                        <Box sx={box}>
                            <Typography sx={title}>Last ip : </Typography>
                            <Typography sx={item}>{props.selected.user.ip}</Typography>
                        </Box>
                        <Box sx={box}>
                            <Typography sx={title}>Created at : </Typography>
                            <Typography sx={item}>{formatTimestamp(props.selected.user.timestamp)}</Typography>
                        </Box>

                    </Paper>
                }
            </Box>
        </Box>
    </Modal>
    )
}

export default ViewModal